// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

export { AzureKeyCredential, KeyCredential } from "./azureKeyCredential";

export {
  TokenCredential,
  GetTokenOptions,
  AccessToken,
  isTokenCredential
} from "./tokenCredential";

export { SpanContext, SpanOptions } from "./tracing";
